import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Destinations from "@/components/Destinations";
import Manifesto from "@/components/Manifesto";
import VideoShowcase from "@/components/VideoShowcase";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [preset, setPreset] = useState("");

  const enquire = useCallback((what) => {
    setPreset(what);
    requestAnimationFrame(() => {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    });
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#0B132B] text-slate-100 min-h-screen font-sans overflow-x-clip">
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services onEnquire={enquire} />
        <Destinations onEnquire={enquire} />
        <Manifesto />
        <VideoShowcase />
        <ContactSection presetDestination={preset} />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
